import { Toaster as Sonner, ToasterProps } from "sonner"
import { useEffect, useState } from "react"

type ExtendedToastOptions = ToasterProps["toastOptions"] & {
  success?: { className?: string }
  error?: { className?: string }
}

const Toaster = ({ ...props }: ToasterProps) => {
  const [theme, setTheme] = useState<"light" | "dark" | "system">("system")

  useEffect(() => {
    // Check for dark mode preference
    const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches
    const hasDocumentClass = document.documentElement.classList.contains("dark")

    if (hasDocumentClass) {
      setTheme("dark")
    } else if (isDark) {
      setTheme("dark")
    } else {
      setTheme("light")
    }

    // Listen for theme changes
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    const handleChange = (e: MediaQueryListEvent) => {
      setTheme(e.matches ? "dark" : "light")
    }

    mediaQuery.addEventListener("change", handleChange)
    return () => mediaQuery.removeEventListener("change", handleChange)
  }, [])

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      toastOptions={
        {
          className: "sonner-toast",
          descriptionClassName: "sonner-toast-description",
        } as ExtendedToastOptions
      }
      {...props}
    />
  )
}

export { Toaster }
